import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { fetchProperty } from "../redux/actions/propertyAction";
import { useAppDispatch } from "../redux/hook";
import Pagination from "../utils/Pagination";

export default function Properties({ pagination = true }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Pagination start
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(3);
  // Pagination end

  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadProperty = async () => {
    const data = {
      page: page,
      limit: limit,
    };

    const property = await dispatch(fetchProperty(data));
    if (
      typeof property.payload === "string" ||
      property.payload === undefined
    ) {
      setLoading(false);
      // navigate(checkError(homeEdit.payload));
    } else {
      setLoading(false);
      setPropertyData(property.payload.property);
      setTotalPages(property.payload.totalPages);
      setTotal(property.payload.total);
      setPage(property.payload.page);
      setLimit(property.payload.limit);
    }
  };
  loadProperty();

  useEffect(() => {
    loadProperty(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative lg:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-4 md:text-2xl text-xl font-medium">
            {t("external.property.our_properties")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.property.here_there_are_some_of_our_properties")}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 mt-6 gap-6">
          {pagination
            ? propertyData.map((item, index) => {
                return (
                  <ul className="space-y-6" key={index}>
                    <li className="rounded-xl shadow dark:shadow-gray-800 p-6 bg-white dark:bg-slate-900">
                      <div className="flex items-center pb-6 border-b border-gray-100 dark:border-gray-800">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className="h-14 w-14 rounded-full shadow dark:shadow-gray-800"
                          alt=""
                        />

                        <div className="ps-3">
                          <Link
                            to={`/property/${item.id}`}
                            className="text-[16px] font-medium hover:text-orange-500 duration-500"
                          >
                            {item.name}
                          </Link>
                          <p className="text-slate-400 dark:text-white/60">
                            {item.category}
                          </p>
                        </div>
                      </div>

                      <div className="mt-6">
                        <p className="text-slate-400 dark:text-white/60">
                          {item.address}
                        </p>
                        <ul className="list-none mb-0 text-amber-400 mt-2">
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                );
              })
            : propertyData.slice(0, 3).map((item, index) => {
                return (
                  <ul className="space-y-6" key={index}>
                    <li className="rounded-xl shadow dark:shadow-gray-800 p-6 bg-white dark:bg-slate-900">
                      <div className="flex items-center pb-6 border-b border-gray-100 dark:border-gray-800">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className="h-14 w-14 rounded-full shadow dark:shadow-gray-800"
                          alt=""
                        />

                        <div className="ps-3">
                          <Link
                            to={`/property/${item.id}`}
                            className="text-[16px] font-medium hover:text-orange-500 duration-500"
                          >
                            {item.name}
                          </Link>
                          <p className="text-slate-400 dark:text-white/60">
                            {item.category}
                          </p>
                        </div>
                      </div>

                      <div className="mt-6">
                        <p className="text-slate-400 dark:text-white/60">
                          {item.address}
                        </p>
                        <ul className="list-none mb-0 text-amber-400 mt-2">
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                          <li className="inline">
                            <i className="mdi mdi-star"></i>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                );
              })}
        </div>

        {pagination && (
          <Pagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
            total={total}
          />
        )}
      </div>
    </>
  );
}
